'use strict';

var _ = require('lodash');
var ChartFBCUsageController = function ChartFBCUsageController($scope, chartFBCUsageDataService) {
  $scope.data = [];
  $scope.originalData = [];
  $scope.legend = '';
  $scope.inactiveVisible = true;
  $scope.chartExpandMap = {};
  $scope.getFilterParams = function (brushFilter) {
    return {
      months: _.get(brushFilter, 'filterArguments[0][0].months'),
      market: _.get(brushFilter, 'filterArguments[0][0].market'),
      classes: _.get(brushFilter, 'filterArguments[0][0].classes')
    };
  };
  $scope.retrieveData = function (brushFilter) {
    var params = $scope.getFilterParams(brushFilter);
    $scope.legend = chartFBCUsageDataService.getLegend(params.months);
    $scope.reloadChartsData(params.market, params.classes);
  };
  $scope.reloadChartsData = function (market, classes) {
    chartFBCUsageDataService.getData().then(function (rawData) {
      $scope.data = chartFBCUsageDataService.prepareChartData(rawData, classes, market, $scope.inactiveVisible, $scope.marketTagKey);
    });
  };
  $scope.toggleInactiveVisibility = function () {
    $scope.inactiveVisible = !$scope.inactiveVisible;
    var params = $scope.getFilterParams($scope.filterData['class-usage']);
    $scope.reloadChartsData(params.market, params.classes);
  };
};
ChartFBCUsageController.$inject = ['$scope', 'ChartFBCUsageDataService'];
module.exports = ChartFBCUsageController;